export default "__VITE_ASSET__66640295__"